<template>
  <v-container>
    <v-card-text>
      <v-data-table
        :loading="loadingPagesTable"
        :items="smediaItems"
        :headers="SmediasHeader"
        class="elevation-1"
        disable-pagination
        hide-default-footer
      >
        <template v-slot:[`item.logoFileUrl`]="{ item }">
          <v-img
            width="50"
            height="50"
            :src="item.logoFileUrl.thumbnailFileUrl ? item.logoFileUrl.thumbnailFileUrl : ''"
          />
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="showPage(item)">
                <v-icon color="primary" dark v-bind="attrs" v-on="on">
                  mdi-eye
                </v-icon>
              </v-btn>
            </template>
            <span>مشاهده </span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon @click="editSmedia(item)">
                <v-icon color="primary" dark v-bind="attrs" v-on="on">
                  mdi-lead-pencil
                </v-icon>
              </v-btn>
            </template>
            <span>ویرایش</span>
          </v-tooltip> -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon color="error" @click="deleteSmedia(item)"
                ><v-icon v-bind="attrs" v-on="on">mdi-delete</v-icon></v-btn
              >
            </template>
            <span>حذف</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <div class="text-center pt-5">
        <v-row>
          <v-col cols="12" sm="2" md="2">
            <v-select
              outlined
              dense
              v-model="itemsPerPage"
              :items="[5, 10, 20]"
              label="تعداد نمایش در صفحه"
            ></v-select>
          </v-col>

          <v-col cols="12" sm="10" md="10">
            <v-pagination
              circle
              v-model="pageNumber"
              :length="smediasCount"
              :total-visible="7"
            ></v-pagination>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
  </v-container>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
 
const enumsRepository = () => RepoFactory.get('enums');
const merchantRepository = () => RepoFactory.get('merchant');
import Helper from '@/core/helpers';
import qs from 'qs';
 

export default {
  data() {
    return {
      filterColumn: [],
      savedFilters: [],
      search: '',
      smediaItems: [],
      pageNumber: 1,
      itemsPerPage: 10,
      smediasCount: 0,
      loadingPagesTable: true,
      SmediasHeader: [
        {
          value: 'socialMediaName',
          text: 'نام ',
          sortable: true,
        },
        {
          value: 'membershipId',
          text: 'شناسه کاربری',
          sortable: true,
        },
        {
          value: 'actions',
          text: 'عملیات',
        },
      ],
    };
  },
  created() {
    if (this.currentMerchant != null) {
      this.fetchSmediasItems();
    }
  },
  computed: {
    baseUrl() {
      return this.$store.getters.contentBaseUrl;
    },
    currentMerchant() {
      return this.$store.getters.currentMerchant;
    },
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
  },
  watch: {
    currentMerchant() {
      this.fetchSmediasItems();
    },
    pageNumber() {
      this.fetchSmediasItems();
    },
    itemsPerPage() {
      this.fetchSmediasItems();
    },
    search(val) {
      if (val && val.length >= 3) {
        this.fetchSmediasItems();
      } else {
        this.fetchSmediasItems();
      }  
    },
  },
  methods: {
    getClassTypeModel() {
      enumsRepository()
        .getModel('PageListDto', this.baseUrl)
        .then((res) => {
          this.filterColumn = res.data;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        });
    },
    saveFilter() {
      localStorage.setItem(
        'supplierPagesFilter',
        JSON.stringify(this.$refs.advanceFillterRef.Filters)
      );
    },
  
    openCreateForm() {
      this.$store.commit('setVendorsFormStatus', true);
    },
    fetchSmediasItems() {
      let app = this;
      this.smediaItems = [];
 
 
    
      
      const loader = this.$loading.show();
      merchantRepository()
        .getMerchantSmedias(
          this.$store.getters.currentMerchant,
          app.merchantBaseUrl,
          {},
        )
        .then((res) => {
          if (res.data != null) {
            this.smediaItems = res.data;
 
          } else {
            this.smediaItems = [];
     
          }
          app.loadingPagesTable = false;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => loader.hide());
    },
    editSmedia(item) {
      
      this.$store.commit('setVendorsFormStatus', true);
      this.$store.commit('setVendorsIsEdit', true);
      this.$store.commit('setVendorsSelectedForEdit', item);
      
    },
    deleteSmedia(item) {
      this.$dialog.warning({
        text: `آیا از حذف   <span class="red--text">${item.socialMediaName}</span> اطمینان دارید؟`,
        title: 'هشدار',
        actions: {
          false: {
            color: 'red',
            text: 'خیر',
          },
          true: {
            color: 'primary',
            text: 'بله',
            handle: () => {
              const loader = this.$loading.show();
              merchantRepository()
                .deleteMerchantSmedia(item.id, this.$store.getters.currentMerchant,
                  this.merchantBaseUrl, {},{socialMediaId:item.id})
                .then((res) => {
                  this.fetchSmediasItems();
                  this.$dialog.message.success('با موفقیت حذف گردید', {
                    position: 'top-left',
                  });
                })
                .catch((error) => {
                  Helper.handleErrors(error, this);
                })
                .finally(() => loader.hide());
            },
          },
        },
      });
    },

    showPage(item) {
      let str = item.merchantName.replace(/\s+/g, '-').toLowerCase();
      let supplierUrl =
        this.$store.getters.taksaanUrl +
        '/supplier/' +
 
        item.vendorMerchantId +
         '/' +
        str;
      window.open(supplierUrl, '_blank');
    },
 
  },
   
};
</script>

<style></style>
